var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2296_945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79128 12.9438C9.15447 12.9438 9.4489 13.2265 9.4489 13.5752V16.0476C13.0642 14.0202 15.2393 12.5859 16.5511 11.3336C17.3124 10.6069 17.7311 9.98719 17.9743 9.39624C18.2188 8.80205 18.3268 8.13816 18.3268 7.26116C18.3268 4.12272 15.677 1.57851 12.4082 1.57851H7.80484C4.53609 1.57851 1.88624 4.12272 1.88624 7.26116C1.88624 10.3996 4.53609 12.9438 7.80484 12.9438H8.79128ZM9.4489 17.8724C18.2138 13.0293 19.9709 11.0457 19.9709 7.26116C19.9709 3.25093 16.5849 0 12.4082 0H7.80484C3.6281 0 0.242188 3.25093 0.242188 7.26116C0.242188 11.2714 3.6281 14.5223 7.80484 14.5223V17.6902C7.80484 18.1732 8.34667 18.4772 8.78378 18.238C9.00985 18.1144 9.23153 17.9925 9.4489 17.8724Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2296_945",
    x: 0.242188,
    y: 0,
    width: 19.7287,
    height: 22.3214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2296_945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.b7243180c54fadb22b0f46ec8c69624e.svg";
export { ForwardRef as ReactComponent };